import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import addon_sensors from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import safety_rgbw_plus from '@devices/settings/device_settings/safety_rgbw_plus.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import rgbw_settings_gen_2_no_calibration from '@devices/settings/device_settings/rgbw_settings_gen_2_no_calibration.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default [
	timer_gen_2,
	schedule_gen_2,
	webhooks_gen_2,
	night_mode_gen_2,
	addon_sensors,
	scripts_gen_2,
	networks_gen_2_plus,
	bluetooth_gen_2,
	safety_rgbw_plus,
	app_setting_plus_rgbw_gen_2,
	share,
	rgbw_settings_gen_2_no_calibration,
];
